import axios from "axios";
import React from "react";
import { API_URL } from "./../../../config";

const AddUserButton = ({
  resetState,
  firstName,
  lastName,
  email,
  password,
  admin,
  ownsCourse,
  fetchAllUsers,
}) => {
  const createUser = (data) =>
    axios({
      method: "POST",
      url: `${API_URL}/createUser`,
      withCredentials: true,
      data,
    });

  const handleSubmit = (e) => {
    e.preventDefault();

    createUser({
      firstName,
      lastName,
      email,
      password,
      admin,
      ownsCourse,
    })
      .then(() => {
        alert("New User has been created");
        resetState();
        window.scrollTo(0, 0);
        fetchAllUsers();
      })
      .catch((err) => {
        alert(err.response.data.message);
      });
  };
  return <button onClick={handleSubmit}>Create User</button>;
};

export default AddUserButton;
